import { FormControl } from '@angular/forms';
import { IDropdownOption } from '../mat-dropdown/mat-dropdown.component';

/** Dropdown id standing for "no auto lock", matching the convention of `refreshDataIntervalOptions`. */
export const SCREEN_LOCK_NEVER_ID = -1;

/** Mirrors the API DTO (`SCREEN_LOCK_PIN_PATTERN`) so a bad PIN is rejected before the request is sent. */
export const SCREEN_LOCK_PIN_PATTERN = /^\d{4,12}$/;

export type TScreenLockFormControls = {
  autoLockDuration: FormControl<IDropdownOption[] | null>;
  autoLockPin: FormControl<string | null>;
};

/** What the API expects on the dashboard / slideshow create-update payloads. */
export interface IScreenLockPayload {
  autoLockDurationSeconds: number | null;
  autoLockPin?: string | null;
}

export interface IResolvedScreenLock {
  durationSeconds: number;
  sourceType: 'dashboard' | 'slideshow';
}
